import { defineComponent, computed } from 'vue';
import __vue_component__ from '../ui/Skeleton.vue.js';

/**
 * Keep this component simple and opinionated. If another text style needs to
 * be componentized, create a new component.
 */
var script = defineComponent({
    name: 'Copy',
    components: {
        Skeleton: __vue_component__,
    },
    props: {
        isLoading: Boolean,
        /** Opinionated padding, use CSS if unsuitable. */
        paddingBottom: Boolean,
        /** Opinionated padding, use CSS if unsuitable. */
        paddingTop: Boolean,
        skeletonHeight: {
            type: String,
            default: '16px',
        },
        skeletonMaxWidth: {
            type: String,
            default: null,
        },
        skeletonWidth: {
            type: String,
            default: null,
        },
        skeletonVerticalMargin: {
            type: String,
            default: '2px',
        },
        span: Boolean,
    },
    setup(props) {
        const tag = computed(() => props.span ? 'span' : 'div');
        const classNames = computed(() => {
            const names = [];
            // Padding used as to not collapse with skeleton margins.
            if (props.paddingBottom)
                names.push('pb-4');
            if (props.paddingTop)
                names.push('pt-4');
            return names;
        });
        return {
            classNames,
            tag,
        };
    },
});

export { script as default };
